import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentWrapperComponent } from './components/content-wrapper/content-wrapper.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../shared/material.module';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthModule } from './auth/auth.module';
import { FooterComponent } from './components/footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  declarations: [
    ContentWrapperComponent,
    SidenavComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    // FontAwesomeModule,
    RouterModule,
    HttpClientModule,
    AuthModule,
  ],
  providers: [
  ],
  exports: [
    SidenavComponent,
    ContentWrapperComponent,
    FooterComponent
  ]
})
export class CoreModule { }
